// Canadian provinces and territories
const canadaStates = [
  { code: 'AB', en: 'Alberta' },
  { code: 'BC', en: 'British Columbia' },
  { code: 'MB', en: 'Manitoba' },
  { code: 'NB', en: 'New Brunswick' },
  { code: 'NL', en: 'Newfoundland and Labrador' },
  { code: 'NS', en: 'Nova Scotia' },
  { code: 'NT', en: 'Northwest Territories' },
  { code: 'NU', en: 'Nunavut' },
  { code: 'ON', en: 'Ontario' },
  { code: 'PE', en: 'Prince Edward Island' },
  { code: 'QC', en: 'Quebec' },
  { code: 'SK', en: 'Saskatchewan' },
  { code: 'YT', en: 'Yukon' },
];

const getCanadaStates = () => {
  return canadaStates.map(state => ({
    code: state.en,
    name: state.en,
  }));
};

export default getCanadaStates;
